import { create } from 'zustand';
import { GroupedHypoEvent, GroupedHypoWithTreatment, CalendarEntry } from '../types';

interface HypoStore {
  hypos: GroupedHypoEvent[];
  calendarData: CalendarEntry[];
  selectedHypo: GroupedHypoWithTreatment | null;
  isLoading: boolean;
  error: string | null;

  // Actions
  setHypos: (hypos: GroupedHypoEvent[]) => void;
  setCalendarData: (data: CalendarEntry[]) => void;
  setSelectedHypo: (hypo: GroupedHypoWithTreatment | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useHypoStore = create<HypoStore>((set) => ({
  hypos: [],
  calendarData: [],
  selectedHypo: null,
  isLoading: false,
  error: null,

  setHypos: (hypos) => set({ hypos }),
  setCalendarData: (calendarData) => set({ calendarData }),
  setSelectedHypo: (selectedHypo) => set({ selectedHypo }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  reset: () =>
    set({
      hypos: [],
      calendarData: [],
      selectedHypo: null,
      error: null,
    }),
}));